import {useNavigateWithReload} from "base/navigation/hooks";
import {useErrors} from "base/error/provider";
import {FileUpload} from "base/file/utilities";
import {PermitExtensionService} from "permitextension/service";
import {permit_extension_view_adapter} from "permitextension/model";
import {BaseAlert} from "base/error/model";

// TODO(cmartin): merge with usePermitForm()
const usePermitExtensionForm = (entity, basePath, fileFields) => {
    const navigate = useNavigateWithReload();
    const {handleErrors} = useErrors();

    const handleFormSubmit = (updatedEntity, callback = null) => {
        const objectContainsFiles = FileUpload.objectContainsFiles(updatedEntity);

        if (!objectContainsFiles) {
            updatePermitExtension(updatedEntity).then(() => {
                FileUpload.callCallback(callback, true);
                navigate(basePath, true);
            });
        } else {
            const objectContainsDuplicateFiles =
                FileUpload.objectContainsDuplicateFiles(updatedEntity);

            if (objectContainsDuplicateFiles) {
                const error = new BaseAlert(
                    "error",
                    "Não é permitido selecionar o mesmo ficheiro em mais de um campo."
                );
                handleErrors(error);
                FileUpload.callCallback(callback, false);
                return;
            }

            FileUpload.uploadFiles(updatedEntity, entity, fileFields)
                .then(fileUploadResults => {
                    FileUpload.updateFormWithFileIds(
                        updatedEntity,
                        fileUploadResults,
                        fileFields
                    );
                    return updatePermitExtension(updatedEntity);
                })
                .then(() => {
                    FileUpload.callCallback(callback, true);
                    navigate(basePath, true);
                })
                .catch(fileError => {
                    FileUpload.callCallback(callback, false);
                    handleErrors(fileError.error);
                });
        }
    };

    const updatePermitExtension = updatedEntity => {
        return PermitExtensionService.update(
            permit_extension_view_adapter(updatedEntity)
        ).catch(error => {
            handleErrors(error);
        });
    };

    return {
        handleFormSubmit,
    };
};

export {usePermitExtensionForm};
